'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSpaceUsage = exports.getCurrentAccount = exports.getAccountBatch = exports.getAccount = exports.listFolderContinue = exports.listFolder = exports.getMetadata = exports.createFolder = exports.copy = undefined;

var _httpClient = require('http-client');

var bearerToken = function bearerToken(token) {
  return (0, _httpClient.auth)('Bearer ' + token);
};

var apiVersion = function apiVersion(version) {
  return (0, _httpClient.base)('https://api.dropboxapi.com/' + version);
};

var returnJSON = (0, _httpClient.createStack)((0, _httpClient.parseJSON)(), (0, _httpClient.handleResponse)(function (response) {
  var data = response.jsonData;

  if (data.error_summary) throw new Error(data.error_summary);

  return data;
}));

var post = function post(token, path) {
  return (0, _httpClient.createFetch)((0, _httpClient.method)('POST'), bearerToken(token), apiVersion(2), returnJSON)(path);
};

var postParams = function postParams(token, path, params) {
  return (0, _httpClient.createFetch)((0, _httpClient.method)('POST'), bearerToken(token), apiVersion(2), (0, _httpClient.json)(params), returnJSON)(path);
};

var copy = exports.copy = function copy(token) {
  var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  return postParams(token, '/files/copy', params);
};

var createFolder = exports.createFolder = function createFolder(token) {
  var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  return postParams(token, '/files/create_folder', params);
};

var getMetadata = exports.getMetadata = function getMetadata(token) {
  var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  return postParams(token, '/files/get_metadata', params);
};

var listFolder = exports.listFolder = function listFolder(token) {
  var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  return postParams(token, '/files/list_folder', params);
};

var listFolderContinue = exports.listFolderContinue = function listFolderContinue(token) {
  var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  return postParams(token, '/files/list_folder/continue', params);
};

var getAccount = exports.getAccount = function getAccount(token) {
  var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  return postParams(token, '/users/get_account', params);
};

var getAccountBatch = exports.getAccountBatch = function getAccountBatch(token) {
  var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  return postParams(token, '/users/get_account_batch', params);
};

var getCurrentAccount = exports.getCurrentAccount = function getCurrentAccount(token) {
  return post(token, '/users/get_current_account');
};

var getSpaceUsage = exports.getSpaceUsage = function getSpaceUsage(token) {
  return post(token, '/users/get_space_usage');
};


//////////////////
// WEBPACK FOOTER
// ./~/dropbox-client/lib/DropboxRPC.js
// module id = 101
// module chunks = 0